import { DeleteButton, SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { TreePalm } from "lucide-react";
import { DateInput, Edit, SelectInput, SimpleForm, TextInput } from "../common";

const typeChoices = [
  { id: "public", name: "Public" },
  { id: "optional", name: "Optional" },
  { id: "company", name: "Company" },
];

const HolidayEditToolbar = () => (
  <div className="form-toolbar-premium">
    <DeleteButton className="btn-delete-action" />
    <SaveButton className="btn-green-action" label="Update Holiday" />
  </div>
);

export const HolidayEdit = () => (
  <Edit title="Edit Holiday" actions={false}>
    <Card className="form-container">
      <div className="form-header-premium">
        <TreePalm className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Edit Holiday Details</h2>
      </div>
      <SimpleForm toolbar={<HolidayEditToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <DateInput source="date" />
          <SelectInput source="type" choices={typeChoices} />
        </div>
        <TextInput source="name" fullWidth className="mt-4" />
      </SimpleForm>
    </Card>
  </Edit>
);

